import React from 'react'
import classNames from 'classnames'
import { Button, type IButtonProps } from 'shared/ui/Button/ui/Button'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard'
import styles from './styles.module.scss'

type IButtonCopyProps = {
  value: string | number | undefined
  buttonProps?: Partial<IButtonProps<keyof HTMLElementTagNameMap>>
}

export const ButtonCopy = ({ value, buttonProps }: IButtonCopyProps) => {
  const { onCopy, copied } = useCopyToClipboard(value)
  const { className, ...restButtonProps } = buttonProps ?? {}

  return (
    <div className={classNames(styles.container, { [styles.copied]: copied })}>
      <Button
        icon='copy'
        text='Copy'
        typeBtn='contained'
        contained='tertiary'
        size='small'
        onClick={onCopy}
        className={classNames(styles.layer, copied ? styles.hidden : styles.visible, className)}
        {...restButtonProps}
      />
      <Button
        text='Copied'
        typeBtn='contained'
        contained='tertiary'
        size='small'
        onClick={onCopy}
        className={classNames(styles.layer, copied ? styles.visible : styles.hidden, className)}
        {...restButtonProps}
      />
    </div>
  )
}
